
import {onMounted, onUpdated, reactive, ref} from 'vue';
import { useMediaQuery, useResizeObserver } from "@vueuse/core";
import RecipesDesktop from './recipesDesktop.vue';
import RecipesMobile from './recipesMobile.vue';


export default {
	name: 'Recipes',
	components: {
		RecipesDesktop,
		RecipesMobile
	},
	setup() {
		const isDesktop = ref(useMediaQuery('(min-width: 992px)'));
		const componentName = ref(isDesktop.value ? "RecipesDesktop" : "RecipesMobile");
		const recipeApp = ref(null)

		useResizeObserver(recipeApp, (entries) => {
			componentName.value = isDesktop.value ? "RecipesDesktop" : "RecipesMobile";
		})

		return {
			componentName,
			recipeApp
		};
	}
};
